import React, { Component } from 'react';
import { Alert, Timmer } from "../../../js/ComponentManager";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능: 내정보 수정
 * 세부설명:
*/

export class MyInfo extends Component {
    static displayName = MyInfo.name;

    constructor(props) {
        super(props);
        this.state = {
            MemberModel: {
                User_Name: "",
                User_Phone: "",
                User_Phone_Old: "", //핸드폰 변경시 비교용
                Password: "",
                PasswordCheck: "",
                Optionagr_Yn: false,
                Certifi_No: ""
            },
            UserNameModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            PhoneModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            CertifiModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            PassModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Pass2Model: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Content: "",
            Title: "정보수정",
            Certifi_Css: "item_hide", // 인증번호 입력 가능 보이기
            SeqNo: "",                // 인증번호 발송 Seq
            CertifiNumberOk: false,   //인증성공여부
            isCertifiClick: false,   //인증버튼 재클릭 금지
            RegisterSuccess: false    //회원수정 완료
        };

        this.refTimmer = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleCertifiSend = this.handleCertifiSend.bind(this);
        this.handleCertifiValid = this.handleCertifiValid.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleAlertClick = this.handleAlertClick.bind(this);

    }
    jsonAttr = { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false }
    //초기화
    componentDidMount() {

        //MyInfoCheck에서 비밀번호 확인이 되지 않았을 경우 MyInfoCheck 컴포넌트로 다시 보낸다.
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            if (!this.props.ContentState.pwdCheckOk) {
                this.props.RenderComponent('MyInfoCheck');
            }
        }
        else {
            this.props.RenderComponent('MyInfoCheck');
        }

        this.CallMyInfoData();
    }
    //입력값 바인딩
    async CallMyInfoData() {
        try {
            let Data = await Big3Common.Get('api/MyPage/MyInfoMgr/GetMyInfo');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let MyInfoData = JSON.parse(Data.dataTable);
                if (MyInfoData.length > 0) {
                    Big3Common.updateStateModel({
                        this: this,
                        modelName: "MemberModel",
                        updateModel: {
                            "User_Name": MyInfoData[0].user_name,
                            "User_Phone": MyInfoData[0].user_phone,
                            "Optionagr_Yn": MyInfoData[0].optionagr_yn === "Y" ? true : false,
                            "User_Phone_Old": MyInfoData[0].user_phone
                        }
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallAlertMsgData: ", e)
        }
        return false;
    }
    handleChange(event) {
        //이름은 한글/영문만 입력 되게 처리
        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "User_Phone" || tagId === "Certifi_No") {
            //핸드폰,인증번호 숫자만 입력 되게 처리
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "MemberModel" });
        return false;
    }
    //검증속성 기본값
    AttrDefaultSet() {
        this.jsonAttr.Hide = "item_hide"; //input_txt,item_hide
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "item_hide"; //false,check,item_hide
    }
    //검증속성 Good
    AttrCheckOkSet() {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = true;
        this.jsonAttr.ChkCss = "check";
    }
    //검증속성 No Good
    AttrErrorSet(Msg) {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = Msg;
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "false";
    }
    GetModelName(tagId) {
        if (tagId === "User_Name") {
            return "UserNameModel";
        }
        else if (tagId === "User_Phone") {
            return "PhoneModel";
        }
        else if (tagId === "Certifi_No") {
            return "CertifiModel";
        }
        else if (tagId === "Password") {
            return "PassModel";
        }
        else if (tagId === "PasswordCheck") {
            return "Pass2Model";
        }
        else {
            return "";
        }
    }
    //값 검증, 핸드폰번호가 변경될 경우 인증번호 전송버튼 활성화
    async handleBlur(event) {

        let tagId = event.target.id;
        let ModelName = this.GetModelName(tagId);
        let ModelValue = this.state.MemberModel[tagId];
        let ModelLen = ModelValue.length;
        if (ModelLen === 0) {
            this.AttrDefaultSet();
        }
        if (tagId === "User_Name" && ModelLen > 0) {
            this.AttrCheckOkSet();
        }
        else if (tagId === "User_Phone" && ModelLen > 0) {
            let isCheck = Big3Common.Util.HandPhoneCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                //휴대번호를 변경할 경우
                let hpFormat = Big3Common.Util.HandPhoneFormat(ModelValue);
                if (hpFormat !== this.state.MemberModel.User_Phone_Old) {
                    let Data = await Big3Common.Post("api/Common/Common/PhoneNumberValid", { "user_phone": hpFormat });
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        //인증성공
                        Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
                        //핸드폰 중복체크 하고 성공이면 아래 로직
                        this.AttrCheckOkSet();
                        this.jsonAttr.Hide = "input_txt";
                        this.jsonAttr.Msg = "인증번호 전송 버튼을 클릭하세요.";
                    }
                    else {
                        //오류
                        this.AttrErrorSet(Data.message);
                    }
                }
                else {
                    //변경이 없거나 다시 동일 핸드폰 번호로 돌려 놓을경우
                    this.AttrDefaultSet();
                    this.refTimmer.current.Stop();
                    //인증성공, 인증서 발송, 입력 초기화
                    Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
                    this.setState({ "CertifiNumberOk": false, "isCertifiClick": false, Certifi_Css: "item_hide" });
                }

            }
        }
        else if (tagId === "Password" && ModelLen > 0) {
            let isCheck = Big3Common.Util.isPassWordValid(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요.");
            }
            else {
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "PasswordCheck" && ModelLen > 0) {
            if (this.state.MemberModel.Password !== this.state.MemberModel.PasswordCheck) {
                this.AttrErrorSet("비밀번호가 일치하지 않습니다.");
            }
            else {
                this.AttrCheckOkSet();
            }
        }
        if (ModelName === "") return false;


        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        event.preventDefault();
    }
    //입력값 클리어
    handleClear_Click(tagId) {
        let ModelName = this.GetModelName(tagId);
        Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: "" } });
        this.AttrDefaultSet();
        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        return false;
    }
    //인증번호 발송
    async handleCertifiSend(event) {

        if (!this.state.PhoneModel.CheckOk) {
            this.AttrErrorSet("핸드폰 번호를 확인하여 주세요.");
            Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
        }
        else {
            if (this.state.isCertifiClick) {
                return false;
            }
            this.setState({ "isCertifiClick": true });

            try {
                let Data = await Big3Common.Post("api/Common/Common/Certifino", { "user_phone": this.state.MemberModel.User_Phone });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let seqno = Data.objectData;
                    this.setState({ "SeqNo": seqno });
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });

                    //재전송 클릭 시 입력시간 초과 메세지 클리어
                    this.AttrDefaultSet();
                    Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });

                    //인증번호 전송 후 타이머 쇼
                    this.setState({ Certifi_Css: "input_line" });
                    this.refTimmer.current.Play();
                }
                else {
                    this.AttrErrorSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
                }
            }
            catch (e) {
                console.log("handleCertifiSend: ", e);
            }


        }

        event.preventDefault();
    }
    //인증번호 확인
    async handleCertifiValid(event) {
        if (this.state.CertifiNumberOk === true) {
            //이미 인증했음.
            return false;
        }
        if (this.refTimmer.current.isTimeOut()) {
            this.AttrErrorSet("입력시간이 초과 되었습니다.");
            this.setState({ "SeqNo": "", "isCertifiClick": false });
        }
        else if (this.state.MemberModel.Certifi_No.trim().length === 0) {
            this.AttrErrorSet("인증번호를 입력하여 주세요.");
        }
        else {
            try {
                let Data = await Big3Common.Post("api/Common/Common/CertifinoVerification", { "seqno": this.state.SeqNo, "certifi_no": this.state.MemberModel.Certifi_No });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //인증성공
                    this.setState({ "CertifiNumberOk": true });
                    this.refTimmer.current.Stop();
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                }
                else if (Data.codeName === Big3Common.ResultCode.Warning) {
                    //인증번호 불일치
                    this.AttrErrorSet(Data.message);
                }
                else {
                    //오류
                    this.AttrErrorSet(Data.message);
                    this.setState({ "SeqNo": "", "isCertifiClick": false });
                }
            }
            catch (e) {
                console.log("handleCertifiValid :", e);
            }
        }
        Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });
        event.preventDefault();
    }
    async handleSave() {
        if (this.state.MemberModel.User_Name===null || this.state.MemberModel.User_Name.length === 0) {
            this.setState({ Content: "대표자명을 입력하세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else if (this.state.MemberModel.User_Phone !== this.state.MemberModel.User_Phone_Old) {
            if (this.state.MemberModel.User_Phone.trim().length === 0) {
                this.setState({ Content: "휴대폰번호를 입력하세요." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else if (!this.state.PhoneModel.CheckOk) {
                this.setState({ Content: "휴대폰번호 확인하여 주세요." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else if (this.state.MemberModel.Certifi_No.trim().length === 0) {
                this.setState({ Content: "인증번호를 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else if (!this.state.CertifiModel.CheckOk) {
                this.setState({ Content: "인증번호가 일치하지 않습니다." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else if (!this.state.CertifiNumberOk) {
                this.setState({ Content: "인증번호 인증이 완료되지 않았습니다." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }

        }
        else if (this.state.MemberModel.Password.trim().length > 0 && this.state.MemberModel.Password.trim() !== this.state.MemberModel.PasswordCheck.trim()) {
            this.setState({ Content: "비밀번호가 일치하지 않습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else if (this.state.MemberModel.Password.trim().length > 0 && this.state.PassModel.CheckOk !== true) {
            this.setState({ Content: "비밀번호는 영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }

        //회원정보 저장
        try {

            let MemberModel = this.state.MemberModel;
            MemberModel.SeqNo = this.state.SeqNo;
            let Data = await Big3Common.Post("api/MyPage/MyInfoMgr/ModifyMyInfo", MemberModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message, RegisterSuccess: true });
            }
            else {
                this.setState({ Title: "정보수정 오류", Content: Data.message });
            }
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            
        }
        catch (e) {
            console.log("handleSave :", e);
        }
        return false;

    }
    handleAlertClick() {
        if (this.state.RegisterSuccess) {
            this.props.RenderComponent('MyPage');
        }
    }
    render() {
        return (
            <form>
                <div className="container_box p_b_margin c_padding">
                    <div className="input_line">
                        <label>대표자명</label>
                        <input type="text"
                            id="User_Name"
                            className="form-control"
                            maxLength="10"
                            placeholder="실명을 입력하세요"
                            value={this.state.MemberModel.User_Name||""}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                    </div>
                    <div className="input_line">
                        <label>휴대폰번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="User_Phone"
                                className="form-control cn_input"
                                maxLength="13"
                                placeholder="휴대폰번호를 입력하세요."
                                value={this.state.MemberModel.User_Phone||""}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                            />
                            {
                                this.state.MemberModel.User_Phone === this.state.MemberModel.User_Phone_Old ?
                                    <button type="button" className="cn_button btn_inactive">인증번호 전송</button> :
                                    <button type="button" className="cn_button btn_v1" onClick={this.handleCertifiSend}>인증번호 전송</button>
                            }

                        </div>
                        <div className={this.state.PhoneModel.Hide}>{this.state.PhoneModel.Msg}</div>
                    </div>
                    <div className={this.state.Certifi_Css} >
                        <label>인증번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="Certifi_No"
                                className="form-control cn_input"
                                maxLength="6"
                                value={this.state.MemberModel.Certifi_No ||""}
                                onChange={this.handleChange}
                            />
                            <button type="button" className={this.state.CertifiNumberOk === true ? "cn_button btn_inactive" : "cn_button btn_v1"} onClick={this.handleCertifiValid}>인증 확인</button>
                            <div className="time_1">
                                <Timmer Minutes="5"
                                    Seconds="0"
                                    ref={this.refTimmer}
                                />
                            </div>
                        </div>
                        <div className={this.state.CertifiModel.Hide}>{this.state.CertifiModel.Msg}</div>
                        <div className={this.state.CertifiModel.ChkCss} style={{ marginRight: 170 }} onClick={() => this.handleClear_Click('Certifi_No')}  ></div>
                    </div>
                    <div className="input_line my_info_input_line">
                        <label>비밀번호</label>
                        <input type="password"
                            id="Password"
                            className="form-control"
                            maxLength="20"
                            autoComplete="off"
                            placeholder="비밀번호를 등록하여 주세요."
                            value={this.state.MemberModel.Password ||""}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.PassModel.Hide}>{this.state.PassModel.Msg}</div>
                        <div className={this.state.PassModel.ChkCss} onClick={() => this.handleClear_Click('Password')}></div>
                    </div>
                    <div className="input_line my_info_input_line">
                        <label>비밀번호 확인</label>
                        <input type="password"
                            id="PasswordCheck"
                            className="form-control"
                            maxLength="20"
                            autoComplete="off"
                            placeholder="비밀번호를 확인을 등록하여 주세요."
                            value={this.state.MemberModel.PasswordCheck ||""}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.Pass2Model.Hide}>{this.state.Pass2Model.Msg}</div>
                        <div className={this.state.Pass2Model.ChkCss} onClick={() => this.handleClear_Click('PasswordCheck')}></div>
                    </div>
                    <div className="agree_line my_info_agree_line">
                        <div className="agree_line_in">
                            <input className="form-check-input"
                                type="checkbox"
                                id="Optionagr_Yn"
                                onChange={this.handleChange}
                                checked={this.state.MemberModel.Optionagr_Yn || false}
                            />
                            <label className="form-check-label">
                                [선택] 마케팅수신약관에 동의합니다
                            </label>
                        </div>
                        <a href="#!" className="go_page" onClick={(e) => { Big3Common.Util.OpenWindowLink('https://we.big3.kr/privacy2.html',true); e.preventDefault(); }} > </a>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleSave}>정보수정</button>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                    AlertClick={this.handleAlertClick}
                />
            </form>
        );
    }
}
